<img *ngIf="mostrarImg" [src]="rutaImagen" height="35" width="35" alt=""><label for={{id}}
                                                                                [class]="claseLabel">{{label}}</label>
<select [ngClass]="{'is-invalid': control.invalid && control.dirty, 'is-valid': control.valid && control.dirty}"
        class="form-control custom-select"
        [(ngModel)]="value"
        [id]="id"
        [disabled]="habilitar">
  <!-- <option value="" disabled>Seleccione una opcion</option> -->
  <option [ngValue]=null disabled>Seleccione una opción</option>
  <option
    *ngFor="let cmb of comboBox"
    [ngValue]="cmb[idOpcion]">{{cmb[opcion]}}</option>
</select>
<br>